import Honeybadger from '@honeybadger-io/js';

// Every substitution made while reading one response is reported here as a
// single fault. `'Extraction error'` is a constant so Honeybadger groups all
// of them into one fault rather than one per wording; what differs between
// reports lives in the message and the context.
//
// A boundary reaches this through `withExtractionReport`, which is what
// collects a response's substitutions into the one call. Called directly from
// a boundary it reports per field instead, which is a burst of faults for a
// body that is simply the wrong shape.
export default function reportExtractionFailure(
  messages: string[],
  json: unknown
): void {
  const error = new Error('Extraction error');

  if (__DEV__) {
    /* eslint-disable no-alert, no-console */
    // Deferred by a tick: logged synchronously alongside the alert below, the
    // console output can be dropped.
    setTimeout(() => {
      console.group('Extraction error');
      console.error(messages.join('\n* '), { json });
      console.trace();
      console.groupEnd();
    }, 0);

    alert('Extraction error! Check console for more information');
    /* eslint-enable no-alert, no-console */
  } else {
    Honeybadger.notify(error, {
      message: messages.join(', '),
      context: { json }
    });
  }
}
